import { render, staticRenderFns } from "./NAmeMOreSelect.vue?vue&type=template&id=35b886b8&"
import script from "./NAmeMOreSelect.vue?vue&type=script&lang=js&"
export * from "./NAmeMOreSelect.vue?vue&type=script&lang=js&"
import style0 from "./NAmeMOreSelect.vue?vue&type=style&index=0&id=35b886b8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports